<template>
    <div>
        <!-- <tour :steps="passosTour" /> -->
        <section class="row" style="margin-bottom: 0">
            <div class="simulator-container col s12 m9">
                <div class="simulator necessidade-cobertura">
                    <div class="simulator-body">
                        <h4 class="simulator-title">Necessidade<br class="hide-on-small-only"> de Cobertura</h4>
                        <div class="simulator-arrow-container hide-on-small-only">
                            <svg-arrow class="arrow" v-for="i in 4" :key="i" />
                        </div>
                        <div class="simulator-price" id="preco-necessidade-segurado">
                            {{ resumo.necessidade_segurado | dinheiro }}
                        </div>
                    </div>
                    <div class="simulator-footer">
                        <router-link
                            :to="{name: 'cliente_patrimonio', params}"
                            id="link-patrimonio"
                            class="simulator-button with-ball"
                            :class="{active: cliente.patrimonio}">
                            Patrimônio
                        </router-link>
                        <router-link
                            :to="{name: 'cliente_obrigacoes_financeiras', params}"
                            id="link-obrigacao-financeira"
                            class="simulator-button with-ball"
                            :class="{active: cliente.obrigacao_financeira}">
                            Obrigações Financeiras
                        </router-link>
                        <router-link
                            :to="{name: 'cliente_padrao_vida', params}"
                            id="link-padrao-vida"
                            :class="{active: cliente.padrao_vida}"
                            class="simulator-button with-ball">Padrão de Vida</router-link>

                        <router-link
                            v-if="!ignorados.includes('educacao-filhos')"
                            :to="{name: 'cliente_educacao_filhos', params}"
                            id="link-educacao-filhos"
                            :class="{active: cliente.educacao_filhos && cliente.educacao_filhos.filter(e => e.quantidade_despesas).length > 0}"
                            class="simulator-button with-ball">Educação dos Filhos</router-link>

                        <router-link
                             v-if="!ignorados.includes('seguro-renda')"
                            :to="{name: 'cliente_seguros_fonte_renda', params}"
                            id="link-seguro-renda"
                            :class="{active: (cliente.seguros.length + cliente.fontes_renda.length) > 0}"
                            class="simulator-button with-ball">Seguro / Renda</router-link>


                    </div>
                </div>
                <div class="simulator aposentadoria" v-if="exibirAposentadoria">
                    <div class="simulator-body">
                        <h4 class="simulator-title">Aposentadoria</h4>
                        <div class="simulator-arrow-container hide-on-small-only">
                            <svg-arrow class="arrow" v-for="i in 4" :key="i" />
                        </div>
                          <div class="simulator-price" id="preco-necessidade-investimento">
                            {{ resumo.necessidade_investimento | dinheiro }}
                        </div>
                    </div>
                    <div class="simulator-footer">
                        <router-link
                            v-if="!ignorados.includes('projetos')"
                            id="link-projetos"
                            :to="{name: 'cliente_projetos', params}"
                            :class="{active: cliente.projetos.length}"
                            class="simulator-button with-ball">
                            Projetos Futuros
                        </router-link>

                        <router-link
                            v-if="!ignorados.includes('independencia-financeira')"
                            :to="{name: 'cliente_independencia_financeira', params}"
                            id="link-independencia-financeira"
                            :class="{active: independencia_financeira}"
                            class="simulator-button with-ball">
                            Independência Financeira
                        </router-link>
                    </div>
                </div>
            </div>

            <div class="col s12 m3 simulator-sidebar">
                <p>
                    <router-link class="simulator-button fluid secondary" :to="{name: 'gerenciamentoLeads'}">
                        <i class="material-icons">arrow_back</i>
                        <span>Voltar</span>
                    </router-link>
                </p>
                <div class="box-resume">
                    <div class="box-resume-header">
                        RESUMO
                    </div>
                    <div class="box-resume-body">
                        <div class="resume-item">
                            <div style="text-align: right; text-align: right; font-size: 10px;" v-if="cliente.xml_ir_ano">
                                Dados retirados da declaração de imposto de renda {{ cliente.xml_ir_ano }}
                            </div>
                            <h4>Cliente:</h4>
                            <p class="resume-item-body" v-if="cliente.pessoa">
                                {{ cliente.pessoa.pessoa_nome.toUpperCase() }}
                            </p>
                        </div>
                        <div class="resume-item">
                            <h4>Necessidade de cobertura securitária:</h4>
                            <p class="resume-item-body">
                                {{ resumo.necessidade_segurado | dinheiro }}
                            </p>
                        </div>

                        <div class="resume-item" v-if="!ignorados.includes('seguro-renda')">
                            <h4>Seguro:</h4>
                            <p class="resume-item-description">Faz-se necessário avaliar coberturas do seguro atual</p>
                            <p class="resume-item-body">{{ resumo.seguro | dinheiro }}</p>
                            <p class="resume-item-description">Necessidade de complementação:</p>
                            <p class="resume-item-body">{{ resumo.necessidade_segurado - resumo.seguro | dinheiro }}</p>
                        </div>
                        <div class="resume-item" v-if="!ignorados.includes('seguro-renda')">
                            <h4>Renda desprotegida:</h4>
                            <p class="resume-item-body">{{ resumo.renda | dinheiro }}</p>
                        </div>
                        <div class="resume-item" v-if="exibirAposentadoria">
                            <h4>Reserva futura necessária:</h4>
                            <p class="resume-item-body">{{ resumo.aporte_previdencia | dinheiro }}</p>
                        </div>
                         <div class="resume-item" v-if="exibirAposentadoria">
                            <h4>Necessidade de investimento para reserva futura:</h4>
                            <p class="resume-item-body">
                                {{ resumo.necessidade_investimento | dinheiro }}
                            </p>
                        </div>
                        <div class="resume-item" v-if="respondeuTodosQuestionarios">
                            <h4>Perfil Investidor:</h4>
                            <p class="resume-item-body">
                                {{perfilInvestidor}}
                            </p>
                        </div>
                        <div class="resume-item" v-if="rendimento_tributavel">
                            <h4>Rendimento tributável total:</h4>
                            <p class="resume-item-body">
                                {{ rendimento_tributavel | dinheiro }}
                            </p>
                        </div>
                        <div class="resume-item" v-if="limite_deducao">
                            <h4>Limite de dedução da previdência privada:</h4>
                            <p class="resume-item-body">
                                 {{ limite_deducao | dinheiro }}
                            </p>
                        </div>
                        <div class="resume-item" v-if="incentivo_fiscal">
                            <h4>Incentivo fiscal com previdência privada:</h4>
                            <p class="resume-item-body">
                               {{ incentivo_fiscal | dinheiro}}
                            </p>
                        </div>
                    </div>

                </div>
                <p id="link-informacoes-adicionais">
                    <router-link :to="{name: 'cliente_informacoes_adicionais', params}"
                    class="simulator-button fluid with-ball primary"
                    :class="{active: informacaoAdicional}">
                        Informações Adicionais
                    </router-link>
                </p>
                <p class="simulator-footer">
                    <router-link :to="{name: 'perfil_investidor'}"
                    class="simulator-button fluid with-ball primary"
                    :class="{active: respondeuTodosQuestionarios}">
                        Perfil Investidor
                    </router-link>
                </p>
                <p>
                    <button class="simulator-button fluid without-ball secondary" v-if="habilitado" @click="relatorio()">Relatório</button>
                </p>
            </div>
        </section>

    </div>
</template>

<script>

import SvgArrow from "@/components/common/SvgArrow.vue";
import Auth from '@/store/auth';
import { get, post, getUrl, remove } from '@/helpers/api';
import Tour from "@/components/common/MyTour.vue";
import TourHelper from "@/helpers/tour";

import { getAmbiente } from "./../../environment"

export default {

    components: { SvgArrow, Tour },

    computed: {

        ignorados() {
            return getAmbiente().simuladorIgnorar || [];
        },

        exibirAposentadoria() {
            return !['independencia-financeira', 'projetos'].every(item => this.ignorados.includes(item))
        },

        params() {
            return this.$route.params;
        },

        passosTour() {
            const passos = [
                {
                    parent: '#link-patrimonio',
                    target: "#link-patrimonio",
                    content: "Clique nesse botão para cadastrar os dados patrimoniais do cliente.",
                    params: {
                        placement: "bottom",
                    }
                },
                {
                    parent: '#link-obrigacao-financeira',
                    target: "#link-obrigacao-financeira",
                    content: "Clique nesse botão para cadastrar os dados de Obrigação Financeira desse cliente.",
                    params: {
                        placement: "top",
                    }
                },
                {
                    parent: '#link-padrao-vida',
                    target: "#link-padrao-vida",
                    content: "Clique nesse botão para cadastrar os dados de Padrão de Vida do cliente.",
                    params: {
                        placement: "bottom",
                    }
                },
                {
                    parent: '#link-educacao-filhos',
                    target: "#link-educacao-filhos",
                    content: "Clique nesse botão para cadastrar os dados referente à Educação dos Filhos desse cliente.",
                    params: {
                        placement: "top",
                    }
                },
                {
                    parent: '#link-seguro-renda',
                    target: "#link-seguro-renda",
                    content: "Clique nesse botão para cadastrar os dados patrimoniais do cliente.",
                    params: {
                        placement: "bottom",
                    }
                },
                {
                    parent: '#preco-necessidade-segurado',
                    target: "#preco-necessidade-segurado",
                    content: "Essa é a soma total da necessidade do segurado",
                    params: { placement: "left" }
                },

                {
                    parent: '#link-projetos',
                    target: "#link-projetos",
                    content: "Clique nesse botão para cadastrar os Projetos desse cliente.",
                    params: {
                        placement: "top",
                    }
                },

                {
                    parent: '#link-independencia-financeira',
                    target: "#link-independencia-financeira",
                    content: "Clique nesse botão para cadastrar os dados de Independência Finaceira desse cliente.",
                    params: {
                        placement: "top",
                    }
                },
                {
                    parent: "#preco-necessidade-investimento",
                    target: "#preco-necessidade-investimento",
                    content: "Esse é o preço total da aposentadoria desse cliente",
                    params: {
                        placement: "left"
                    }
                },
                {
                    parent: '#link-informacoes-adicionais',
                    target: '#link-informacoes-adicionais',
                    content: 'Clique aqui para cadastrar as informações adicionais desse cliente',
                    params: { placement: "bottom"}
                }

            ];


            return passos;
        },

        habilitado () {

            var keys = [
                'educacao_filhos',
                'fontes_renda',
                'independencia_financeira',
                'obrigacao_financeira',
                'padrao_vida',
                'patrimonio',
                'projeto',
                'seguros',
            ];


            const empresa_tipo_id = Auth.state.user.pessoa.funcionario.empresa.empresa_tipo_id;

            return /*empresa_tipo_id == 1 &&*/ this.cliente && keys.some( key => {
                return this.cliente[key] instanceof Array ? !!this.cliente[key].length : !!this.cliente[key]
            });

        },

        informacaoAdicional () {

            var keys = [
                'medicamento_recorrente',
                'plena_atividade_profissional',
                'pratica_esporte',
                'tratamento_medico',
                'fumante',
                'anotacoes',
            ];

            return this.cliente.informacao_adicional && keys.some( k => this.cliente.informacao_adicional[k] )
        },

        rendimento_tributavel () {
            if  (
                this.cliente.contribuicao_previdencia_privada &&
                this.cliente.contribuicao_previdencia_privada.rendimento_tributavel_total !== 0
            ) {
                return this.cliente.contribuicao_previdencia_privada.rendimento_tributavel_total
            }

        },

        limite_deducao () {
            if (
                this.cliente.contribuicao_previdencia_privada &&
                this.cliente.contribuicao_previdencia_privada.previdencia_privada_ideal !== 0
            ) {
                return this.cliente.contribuicao_previdencia_privada.previdencia_privada_ideal
            }
        },

        incentivo_fiscal () {
            if (
                this.cliente.contribuicao_previdencia_privada &&
                this.cliente.contribuicao_previdencia_privada.irpf_devido_ideal
            ) {
              return  Math.abs(
                  this.cliente.contribuicao_previdencia_privada.irpf_devido -
                  this.cliente.contribuicao_previdencia_privada.irpf_devido_ideal.saldo_imposto
                )
            }
        },

        projetos()
        {
            return this.cliente.projeto && ['valor_necessario', 'valor_reserva', 'tempo_necessario'].some( k => {

                let num = parseFloat(this.cliente.projeto[k])

                return !!num
            })
        },

        independencia_financeira()
        {

            // return this.cliente.independencia_financeira
            return this.cliente.independencia_financeira && ['renda_complementar', 'valor_acumulado', 'aporte_inicial', 'idade_aposentadoria'].some(k => {
                return !! parseFloat(this.cliente.independencia_financeira[k])
            });
        }
    },

    methods: {





        async carregar()
        {
            let {id} = this.$route.params;

            const {data: {result: {data: cliente}}} = await get(`cliente/${id}`);

            this.cliente = cliente;


            const {data: {result: {data: resumo}}} = await get(`resumo/${id}`);

            this.resumo = resumo;

        },

        relatorio () {
            this.$router.push({name:'relatoriosimulador', params:{id:this.$route.params.id}})
        },

        async perfil_investidor () {

            let {id} = this.$route.params;

            const {data: {result: {data: relatorio}}} = await get(`cliente/${id}/relatorio-questionarios-investidor`);

            let valor = parseFloat(relatorio.total);

            this.respondeuTodosQuestionarios = relatorio.quantidade_questionarios === relatorio.quantidade_questionarios_respondidos;

            if (valor === 0) {
                this.perfilInvestidor = '';
            } else if (valor <= 23) {
                this.perfilInvestidor = 'Conservador';
            } else if (valor <= 35) {
                this.perfilInvestidor = 'Moderado';
            } else {
                this.perfilInvestidor = 'Arrojado';
            }

        },
    },

    async created()
    {
        await this.carregar();
        await this.perfil_investidor()
    },


    data() {

        return {
            cliente: {},
            resumo: {},
            perfilInvestidor: '',
            respondeuTodosQuestionarios: false,
            exibe_perfil: false
        };
    },

    watch: {
        '$route'() {

        }
    }
}
</script>



<style lang="scss" scoped>

//$color-primary: #4a6b70;
//$color-secondary: #348eba;
$linear-gradient: linear-gradient(to right, rgba(var(--color-primary-rgb), .8), rgba(var(--color-secondary-rgb), .8));

$mobile: "max-width: 767px";

.simulator-container {

    padding: 0;
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 50px);

     @media (#{$mobile}) {
        min-height: calc(100vh - 50px);
        // padding: 30px;
    }

    .simulator {

        display: flex;
        height: 100%;
        background-size: auto, cover;
        padding: 15px 50px;
        flex-direction: column;
        flex: 1;
        &:first-child{
            border-bottom: 3px solid rgba(255, 255, 255, .15);
        }

        @media (#{$mobile}) {
            padding: 15px;
        }



        .simulator-body{
            display: flex;
            flex: 1;
            align-items: center;
            color: #fff;

            @media (#{$mobile}) {
                flex-wrap: wrap;
            }

            .simulator-arrow-container,
            .simulator-title{
                flex: 1;
            }

            .simulator-arrow-container{
                display: flex;
            }

            .simulator-title{
                font-weight: bold;
                font-size: 40px;
                color: #fff;
                @media (#{$mobile}) {
                    font-size: 25px;
                    text-align: center;
                }
            }

            .simulator-price{
                font-size: 35px;
                background-color: rgba(255, 255, 255, .15);
                border-radius: 4px;
                padding: 10px 15px;

                @media (#{$mobile}) {
                    background-color: transparent;
                    text-align: center;
                    width: 100%;
                }
            }
        }

        .simulator-footer{
            display: flex;

            @media (#{$mobile}) {
                width: 100%;
                flex-direction: column;
                flex-wrap: wrap;
            }
        }

        &.aposentadoria {
            background-image: #{$linear-gradient},
            url('/static/assets/images/simulador/aposentadoria.jpg');
        }

        &.necessidade-cobertura {
            background-image: #{$linear-gradient},
            url('/static/assets/images/simulador/necessidade-cobertura.jpg');
            background-position: top, right 15%;

        }
    }
}

.simulator-sidebar{
    padding: 0 30px;
    height: calc(100vh - 50px);
    overflow: auto;
}

.simulator-button{

    color: #fff;
    padding: 5px 10px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    border: 1px solid #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .15);
    background-color: transparent;
    border-radius: 4px;
    cursor: pointer;

    font-size: 0.85rem;


    &.with-ball::after{
        content: '';
        display: block;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        margin-left: 5px;
        background-color: #fff;
    }

    &.active::after{
        background-color: orange;
    }

    &:not(.active)::after{
        animation: pulse 500ms infinite alternate;
    }

    &.fluid{
        display: flex;
        width: 100%;
        padding: 10px 20px;
    }

    &:not(:last-of-type){
        margin-right: 10px;
    }

    &.primary{
        // background-color: rgb(249, 154, 70);
        //border: 1px solid var(--color-primary);
        border: none;
        background-image: linear-gradient(to left, rgba(var(--color-primary-rgb), 0.5), rgba(var(--color-secondary-rgb), 0.5));
        color: #fff;

        background-color: transparent;
    }

    &.secondary{
        ////background-color: rgb(239, 124, 21);
        //box-shadow: 0 4px 4px #999;
        // border: none;
        background-color: transparent;
        color: var(--color-primary);
        border: 1px solid var(--color-primary);
    }

    @media (#{$mobile}) {
        margin-right: 0;
        margin-bottom: 5px;
        width: 100%;
    }
}


$animation-duration: 1000;

.arrow {
    // transform: rotate(180deg);
    max-width: 80px;
    flex: 0 0 25%;
    fill: rgba(255, 255, 255, 0.1);
    stroke: #fff;
    stroke-width: 0.5px;
    animation: arrow-animation #{$animation-duration}ms ease infinite alternate;

    @for $i from 1 through 4 {
        &:nth-child(#{$i}) {
            animation-delay: #{($i * $animation-duration/4)}ms
        }
    }
}

.box-resume{
    box-shadow: 0 0 4px #ccc;
    border-radius: 4px;
    overflow: hidden;

    .box-resume-header{
        background-color: #ccc;
        padding: 5px;
        color: #666;
        font-size: 20px;
        text-align: center;
    }

    .box-resume-body{

        background-color: #fff;
        padding: 15px;

        .resume-item{
            color: #777;
            border-bottom: 1px solid rgba(0, 0, 0, .15);
            padding-bottom: 15px;
            padding-top: 15px;

            &:last-child{
                border-bottom: none;
            }

            h4 {
                font-size: 20px;
                font-weight: normal;
                margin: 0;
                margin-bottom: 5px;
            }


            .resume-item-body{
                font-weight: bold;
                margin: 0;
                font-size: 18px;
                color: #666;
            }

            .resume-item-description{
                margin: 0;
                margin-bottom: 5px;
            }
        }
    }

}

.flex{
    display: flex;
    width: 100%;
    height: 100%;
    // justify-content: center;
    align-items: center;

    .flex-1{
        flex: 1;
    }
}

@keyframes arrow-animation {
    to {
        stroke: transparent;
    }
}

@keyframes pulse{
    to{
        box-shadow: 0 0 0 15px rgba(#fff, .15);
    }
}


</style>



// WEBPACK FOOTER //
// src/components/simulador/Simulador.vue